module.exports = __webpack_public_path__ + "img/model-x-range-desktop.a1b083ca.png";